// src/components/Navbar.jsx
import { createPortal } from "react-dom";
import React, { useState, useEffect, useRef } from "react";
import "animate.css";
import "./Navbar.css";
import logo from "../tools/oiikotranslogo2.png";
import logo1 from "../tools/oiikotranstxt.png";
import { trackEvent } from "../firebase/analytics";
import { NavLink } from "react-router-dom";

const Navbar = ({ transparent }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const [visible, setVisible] = useState(true);
  const lastY = useRef(0);
  const mounted = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY || 0;
      setScrolled(y > 50);
      const goingDown = y > lastY.current + 6;
      const goingUp = y < lastY.current - 6;
      if (goingDown) setVisible(false);
      if (goingUp) setVisible(true);
      lastY.current = y;
    };
    mounted.current = true;
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // NEW: lock body scroll when menu is open
  useEffect(() => {
    document.body.classList.toggle("no-scroll", menuOpen);
  }, [menuOpen]);

  const toggleMenu = () => {
    trackEvent("mobile_menu_toggle", {
      opened: !menuOpen,
    });
    setMenuOpen((v) => !v);
  };
  const closeMenu = () => setMenuOpen(false);
  const trackNavClick = (label, destination, location = "desktop_nav") => {
    trackEvent("navbar_click", {
      label,
      destination,
      location,
    });
  };
  return (
    <header
      className={[
        "navbar",
        transparent ? "transparent" : "",
        scrolled ? "scrolled" : "",
        "animate__animated",
        mounted.current
          ? visible
            ? "animate__slideInDown"
            : "animate__slideOutUp"
          : "animate__fadeInDown",
        "animate__faster",
      ].join(" ")}
    >
      {/* DESKTOP HEADER (unchanged) */}
      <div className="desktop-navbar">
        <a
          href="/"
          className="brand"
          onClick={() => trackNavClick("logo", "/", "desktop_nav")}
        >
          <img src={logo} alt="Oiiko Logo" className="logoimage" />
          <img src={logo1} alt="Oiiko Logo" className="logoimage1" />
        </a>

        <nav className="desktop-links">
          <NavLink
            to="/industries"
            onClick={() =>
              trackNavClick("industries", "/industries", "desktop_nav")
            }
          >
            Industries
          </NavLink>
          <NavLink
            to="/features"
            onClick={() =>
              trackNavClick("features", "/features", "desktop_nav")
            }
          >
            Features
          </NavLink>

          <NavLink
            to="/pricing"
            onClick={() => trackNavClick("pricing", "/pricing", "desktop_nav")}
          >
            Pricing
          </NavLink>

          <NavLink
            to="/aboutus"
            onClick={() => trackNavClick("about_us", "/aboutus", "desktop_nav")}
          >
            About us
          </NavLink>
        </nav>

        <div className="desktop-actions">
          <a
            href="/register"
            className="join-btn"
            onClick={() => trackNavClick("join", "/register", "desktop_nav")}
          >
            Start Free
          </a>
          <a
            href="/login"
            className="login-btn"
            onClick={() => trackNavClick("login", "/login", "desktop_nav")}
          >
            Login
          </a>
        </div>
      </div>

      {/* MOBILE HEADER */}
      <div className="mobile-navbar">
        <a
          href="/"
          className="brand"
          onClick={() => trackNavClick("logo", "/", "mobile_nav")}
        >
          <img src={logo} alt="Oiiko Logo" className="logoimage" />
          <img src={logo1} alt="Oiiko Logo" className="logoimage1" />
        </a>

        <button
          className="hamburger"
          onClick={toggleMenu}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          <span className={menuOpen ? "bar open" : "bar"} />
          <span className={menuOpen ? "bar open" : "bar"} />
          <span className={menuOpen ? "bar open" : "bar"} />
        </button>

        {/* OVERLAY + FULLSCREEN SHEET */}
        {menuOpen &&
          createPortal(
            <>
              <div className="mobile-overlay" onClick={closeMenu} />

              <div
                id="mobile-menu"
                className={[
                  "mobile-sheet",
                  "animate__animated",
                  "animate__fadeInDown",
                ].join(" ")}
                role="dialog"
                aria-modal="true"
              >
                <div className="sheet-header">
                  <span className="sheet-brand">
                    <img src={logo} alt="" className="logoimage" />
                    <img src={logo1} alt="Oiiko Logo" className="logoimage1" />
                  </span>

                  <button
                    className="sheet-close"
                    onClick={closeMenu}
                    aria-label="Close"
                  >
                    ✕
                  </button>
                </div>

                <nav className="sheet-links">
                  <a
                    href="/features"
                    onClick={() => {
                      trackNavClick("features", "/features", "mobile_nav");
                      closeMenu();
                    }}
                  >
                    Features
                  </a>
                  <a
                    href="/industries"
                    onClick={() => {
                      trackNavClick("industries", "/industries", "mobile_nav");
                      closeMenu();
                    }}
                  >
                    Industries
                  </a>
                  <a
                    href="/pricing"
                    onClick={() => {
                      trackNavClick("pricing", "/pricing", "mobile_nav");
                      closeMenu();
                    }}
                  >
                    Pricing
                  </a>

                  <a
                    href="/aboutus"
                    onClick={() => {
                      trackNavClick("about_us", "/aboutus", "mobile_nav");
                      closeMenu();
                    }}
                  >
                    About us
                  </a>
                </nav>

                <div className="sheet-actions">
                  <a
                    href="/register"
                    className="join-btn block"
                    onClick={() => {
                      trackNavClick("join", "/register", "mobile_nav");
                      closeMenu();
                    }}
                  >
                    Start Free
                  </a>

                  <a
                    href="/login"
                    className="login-btn block"
                    onClick={() => {
                      trackNavClick("login", "/login", "mobile_nav");
                      closeMenu();
                    }}
                  >
                    Login
                  </a>
                </div>
              </div>
            </>,
            document.body,
          )}
      </div>
    </header>
  );
};

export default Navbar;
